import { ZipDeviceControlUnit } from '../../../../redux/controlUnit/controlUnit.model';
import { Device } from '../../../../redux/commander/api/device.model';
import { CHANNELS_METRICS } from './mock/constants';
import { Base64 } from '../../../../util/Base64';

export const getConsumptionsMetrics = (
  devicesControlUnitsSource: ZipDeviceControlUnit[],
  commanders: Device[],
  composableDeviceConsumptions: Record<string, number>
) => {
  return commanders.map((commander, index) => {
    // TODO Remove me when migration of composableDeviceConsumptions UUID is done
    let value = 0;
    if (composableDeviceConsumptions[commander.uuid] !== undefined) {
      value = composableDeviceConsumptions[commander.uuid];
    } else {
      value = composableDeviceConsumptions[Base64.encode(commander.uuid)];
    }
    return {
      name: `consumptions-${commander.uuid}`,
      channels: devicesControlUnitsSource[index].controlUnits
        ?.filter((item) => item.id !== '1002')
        .map((item) => {
          return {
            deviceID: commander.uuid,
            cuID: item.id,
            channelID: 'On',
          };
        }),
      metric: CHANNELS_METRICS.ON_COST,
      options: {
        // defaultCostPerSecond: composableDeviceConsumptions[commander.uuid] / 3600,
        defaultCostPerSecond: (value ?? 0) / 3600,
      },
    } as ReportRealTimeSpec['metrics'][number];
  });
};
